import { useState } from 'react';
import greySquare from '../../assets/images/grey-square.png';

const OrderImage = ({ imgUrl, alt }) => {
  const [imgSrc, setImgSrc] = useState(imgUrl);

  const handleError = () => setImgSrc(greySquare);

  return <img src={imgSrc} onError={handleError} alt={alt} />;
};
export default OrderImage;
